import Vue from 'vue';
export default Vue.extend({});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./src/svgs/leidenschaft/Leidenschaft.ts
// module id = null
// module chunks = 